// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__BsvzL","link":"Nav_link__1Mg-_","active":"Nav_active__1hgj9"};